import React from 'react';
import { Box, Typography } from '@mui/material';

function asMinutesLabel(val) {
  if (val == null) return '';
  const n = Number(val);
  if (!Number.isNaN(n) && String(val).trim() !== '') return `${n} mins`;
  return String(val);
}

function formatTimeLike(value) {
  if (!value) return '';
  const d = new Date(`1970-01-01T${value}`);
  if (!Number.isNaN(d.getTime())) {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
  }
  return String(value);
}

function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  const now = new Date();
  const diffDays = Math.floor((date.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';

  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function BriefOrder({ treatments = [], fallbackTime, fallbackQty, booking = {} }) {
  if (!Array.isArray(treatments) || treatments.length === 0) return null;

  const relativeDateLabel = formatDate(booking?.preferredDate);
  const bookingDateLabel = relativeDateLabel || booking?.metadata?.preferredDateLabel || '';
  const bookingTime = booking?.preferredTime || booking?.time || booking?.startTime || booking?.scheduledAt || fallbackTime || '';
  const bookingQty = booking?.qty || booking?.quantity || booking?.metadata?.count || fallbackQty || 1;

  return (
    <Box sx={{ mt: 1 }}>
      {treatments.map((item, idx) => {
        const name = item?.name || '—';
        const durationRaw = item?.durationLabel ?? item?.duration ?? item?.minutes ?? item?.durationMinutes ?? '';
        const duration = asMinutesLabel(durationRaw);
        const timeText = item?.timeLabel || item?.time || item?.startTime || item?.scheduledAt || bookingTime || '';
        const formattedTime = formatTimeLike(timeText);
        const qty = Number(item?.qty ?? item?.quantity ?? item?.count ?? bookingQty ?? 1);

        return (
          <Typography key={(item._id || name || 't') + String(idx)} variant="body2" color="text.primary">
            <strong>{name}</strong>
            {bookingDateLabel ? <> • {bookingDateLabel}</> : null}
            {formattedTime ? <> • {formattedTime}</> : null}
            {duration ? <> • {duration}</> : null}
            <> • ×{qty}</>
          </Typography>
        );
      })}
    </Box>
  );
}